const SET_PERMISSION = 'permission/SET_PERMISSION' as const;

export type PermissionState = 'SUPER' | null;

export interface Permission {
  permission: PermissionState;
}

export const setPermission = (payload: PermissionState) => ({
  type: SET_PERMISSION,
  payload: payload,
});

type PermissionAction = {
  type: typeof SET_PERMISSION;
  payload: PermissionState;
};

const initialState: Permission = {
  permission: null,
};
const permissionReducer = (
  state: Permission = initialState,
  action: PermissionAction
): Permission => {
  switch (action.type) {
    case SET_PERMISSION:
      return { ...state, permission: action.payload };

    default:
      return state;
  }
};

export default permissionReducer;
